import { MEXICO_PROVINCES } from "_common/regions/regions";
import { TAttraction } from "../attractions";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";

export const campecheAttraction: TAttraction[] = [
    {
        name: "Alberto Acuña Ongay International Airport (CPE)",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 19.8140443,
            lng: -90.5064675,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Ciudad del Carmen International Airport (CME)",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 18.6510592,
            lng: -91.8050153,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Mayan Train - Calkiní",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 20.3775,
            lng: -90.0702103,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Hecelchekán",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 20.3775,
            lng: -90.0702103,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Tenabo",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 20.04033,
            lng: -90.2465403,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - San Francisco de Campeche",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 19.8245793,
            lng: -90.4790928,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Edzná",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 19.59253,
            lng: -90.3722503,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Carillo Puerto-Champotón",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 19.09272,
            lng: -90.5239888,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Escárcega",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 18.61248,
            lng: -90.7338203,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Candelaria",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 18.1842868,
            lng: -91.0494603,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Centenario",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 18.6557406,
            lng: -90.2891539,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Calakmul",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 18.5312712,
            lng: -89.9069968,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Xpujil",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 18.4989,
            lng: -89.3806,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "ADO Campeche",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 19.8232785,
            lng: -90.6725411,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "Playa Bonita",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 19.7936243,
            lng: -90.6217489,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Bahamita",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 18.6905851,
            lng: -91.7151859,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Payucan Balneario Popular",
        region: MEXICO_PROVINCES.CAM,
        coordinates: {
            lat: 19.6612403,
            lng: -90.7034345,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
];
